import { render, staticRenderFns } from "./VTour.vue?vue&type=template&id=f4b97d58&"
import script from "./VTour.vue?vue&type=script&lang=js&"
export * from "./VTour.vue?vue&type=script&lang=js&"
import style0 from "./VTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports